import * as React from "react";
import { NextPageContext } from "next";
import { NextSeo } from "next-seo";

import { DarwinPageContext, isServer } from "../_app";
import CellBioPage from "../../components/pages/cell-bio-list";

const CellBioIndex = () => {
  return (
    <>
      <NextSeo
        title="All Cell Products"
        description="Browse all cell products in the ATCC Genome Portal"
      />
      <CellBioPage collectionName={null} />
    </>
  );
};

CellBioIndex.getInitialProps = async (ctx: NextPageContext & DarwinPageContext) => {
  if (!isServer) {
    return {};
  }
  await ctx.rootStore.cellBioStore.serverSideInitialFetch(null, ctx.query);
  return {};
};

export default CellBioIndex;
